module.exports = __webpack_public_path__ + "static/media/windows3.8e92ac5d.png";